import React from "react";
import { Link } from "react-router-dom";
import RightArrow from "../SVG";

import blogBG from "../../assets/img/blog/bg-1.jpg";
import Image from "../../assets/img/blog/blog-1-1.jpg";

const BlogNews = (props) => {
  const {
    itemClass,
    blogImage,
    publishedDate,
    commentCount,
    heading,
    title,
    btnClass,
    btnText,
    hasArrow,
    _id,
    type = "event",
  } = props;

  const detailLink =
    type === "news" ? `/news-details?id=${_id}` : `/event-details?id=${_id}`;

  return (
    <div
      className="it-blog-item-box h-[400px]"
      style={{ backgroundImage: `url(${blogBG})` }}
    >
      <div className={itemClass ? itemClass : "it-blog-item"}>
        <div className="it-blog-meta pb-15">
          <span>
            <i className="fa-solid fa-calendar-days"></i>
            {publishedDate ? publishedDate : "14 June 2023"}
          </span>
        </div>
        <h4 className="it-blog-title">
          <Link to={detailLink}>{heading}</Link>
        </h4>
        {type === "event" ? (
          <div className="it-about-text line-clamp-2 truncate">
            <p>{title}</p>
          </div>
        ) : (
          <div
            className="event-description-content -mt-3 mb-3"
            dangerouslySetInnerHTML={{ __html: title }}
          />
        )}

        <Link className={btnClass ? btnClass : "ed-btn-blog"} to={detailLink}>
          {btnText ? btnText : "read more"}
          {hasArrow && (
            <i>
              <RightArrow />
            </i>
          )}
        </Link>
      </div>
    </div>
  );
};

export default BlogNews;
